import Ajax from '../common/ajax'
import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'subject',
  testAudio (text) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}`, { text })
  }
}
